// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rEZM_","textarea":"styles_textarea__2-kfL"};